import { get } from 'lodash';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import PositionSection from './PositionSection';
import JobRequestWorksheetBilling from './Billing';
import JobRequestWorksheetSchedule from './Schedule';
import JobRequestWorksheetSkills from './Skills';
import JobRequestDescription from './Description';
import { JOB_REQUEST_STATUS } from '../../../../../common/enums'

function JobRequestWorksheetProfile(props) {
  const {
    staticData = {},
    labels = {},
    jobRequest = null,
    primaryContact = null,
    handleSave
  } = props;

  let disabled = jobRequest.jobRequestStatus >= JOB_REQUEST_STATUS.NA;

  return (
    <div className='job-request-worksheet-profile'>
      <PositionSection
        disabled={disabled}
        handleSave={handleSave}
        jobRequest={jobRequest}
        labels={labels.position}
        staticData={staticData}
      />
      <JobRequestDescription
        handleSave={handleSave}
        staticData={staticData}
        primaryContact={primaryContact}
        jobRequest={jobRequest}
        disabled={disabled}
      />

      <JobRequestWorksheetSkills
        handleSave={handleSave}
        staticData={staticData}
        primaryContact={primaryContact}
        jobRequest={jobRequest}
        disabled={disabled}
      />

      <JobRequestWorksheetSchedule
        handleSave={handleSave}
        staticData={staticData}
        primaryContact={primaryContact}
        jobRequest={jobRequest}
        disabled={disabled}
      />

      <JobRequestWorksheetBilling
        handleSave={handleSave}
        staticData={staticData}
        primaryContact={primaryContact}
        jobRequest={jobRequest}
        disabled={disabled}
        labels={labels.billing}
      />


    </div>
  );
}

JobRequestWorksheetProfile.propTypes = {
  handleSave    : PropTypes.func.isRequired,
  staticData    : PropTypes.object.isRequired,
  labels        : PropTypes.object.isRequired,
  jobRequest    : PropTypes.object.isRequired,
  user          : PropTypes.object,
  primaryContact: PropTypes.object,
  contacts      : PropTypes.array,
  dispatch      : PropTypes.func
};

export default connect((state) => {

  const allContacts = state.companyContacts;
  const primaryContact = allContacts.find((contact) => contact.profile.id === get(state.jobRequest, 'primaryContactId', null));

  return {
    staticData: state.staticData,
    jobRequest: state.jobRequest,
    primaryContact,
    user: state.user,
		contacts: allContacts,
    labels: get(state, 'labels.jobRequest', {})
  };
})(JobRequestWorksheetProfile);



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Profile/index.js